/**
 * Why is this file in vanilla JS?
 *
 * Because we import it in places like `next.config.js` to define some redirects
 * and rewrites. It is still strictly-typed though, via TSDoc:
 *
 * https://tsdoc.org/
 */

/**
 * @type {import("./locales.types").Locale[]} locales
 */
export const locales = [
  {
    localeString: "ae-ar",
    market: "ae",
    lang: "ar",
    hreflang: "ar-AE",
    dir: "rtl",
    localeMixing: ["ar-MEA"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "ae-en",
    market: "ae",
    lang: "en",
    hreflang: "en-AE",
    dir: "ltr",
    localeMixing: ["en-MEA", "en-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "al-sq",
    market: "al",
    lang: "sq",
    hreflang: "sq-AL",
    dir: "ltr",
    localeMixing: ["en-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "ao-pt",
    market: "ao",
    lang: "pt",
    hreflang: "pt-AO",
    dir: "ltr",
    localeMixing: ["pt-AO"],
    storyblokLaunched: false,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "v3-widget",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: false,
    supportHubHomepageVariant: "image",
    measurementSystem: "metric",
  },
  {
    localeString: "ar-es",
    market: "ar",
    lang: "es",
    hreflang: "es-AR",
    dir: "ltr",
    localeMixing: ["es-AR", "es-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "at-de",
    market: "at",
    lang: "de",
    hreflang: "de-AT",
    dir: "ltr",
    localeMixing: ["de-AT", "de-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "au-en",
    market: "au",
    lang: "en",
    hreflang: "en-AU",
    dir: "ltr",
    localeMixing: ["en-AU", "en-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "az-az",
    market: "az",
    lang: "az",
    hreflang: "az-AZ",
    dir: "ltr",
    localeMixing: ["az-AZ"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "ba-bs",
    market: "ba",
    lang: "bs",
    hreflang: "bs-BA",
    dir: "ltr",
    localeMixing: ["bs-BA"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "be-fr",
    market: "be",
    lang: "fr",
    hreflang: "fr-BE",
    dir: "ltr",
    localeMixing: ["fr-BE", "fr-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "be-nl",
    market: "be",
    lang: "nl",
    hreflang: "nl-BE",
    dir: "ltr",
    localeMixing: ["nl-BE"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "bg-bg",
    market: "bg",
    lang: "bg",
    hreflang: "bg-BG",
    dir: "ltr",
    localeMixing: ["bg-BG", "en-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "br-pt",
    market: "br",
    lang: "pt",
    hreflang: "pt-BR",
    dir: "ltr",
    localeMixing: ["pt-BR"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "ca-en",
    market: "ca",
    lang: "en",
    hreflang: "en-CA",
    dir: "ltr",
    localeMixing: ["en-CA", "en-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "ca-fr",
    market: "ca",
    lang: "fr",
    hreflang: "fr-CA",
    dir: "ltr",
    localeMixing: ["fr-CA", "fr-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "car-es",
    market: "car",
    lang: "es",
    hreflang: "es-419",
    dir: "ltr",
    localeMixing: ["es-CAR", "es-INT"],
    storyblokLaunched: false,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "v3-widget",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: false,
    supportHubHomepageVariant: "image",
    measurementSystem: "metric",
  },
  {
    localeString: "ch-de",
    market: "ch",
    lang: "de",
    hreflang: "de-CH",
    dir: "ltr",
    localeMixing: ["de-CH", "de-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "ch-fr",
    market: "ch",
    lang: "fr",
    hreflang: "fr-CH",
    dir: "ltr",
    localeMixing: ["fr-CH", "fr-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "ci-fr",
    market: "ci",
    lang: "fr",
    hreflang: "fr-CI",
    dir: "ltr",
    localeMixing: ["fr-CI"],
    storyblokLaunched: false,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "v3-widget",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: false,
    supportHubHomepageVariant: "image",
    measurementSystem: "metric",
  },
  {
    localeString: "cl-es",
    market: "cl",
    lang: "es",
    hreflang: "es-CL",
    dir: "ltr",
    localeMixing: ["es-CL", "es-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: "cl",
    highInSugarMark: "cl",
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "cn-zh",
    market: "cn",
    lang: "zh",
    hreflang: "zh-CN",
    dir: "ltr",
    localeMixing: ["zh-CN"],
    storyblokLaunched: false,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "disabled",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "co-es",
    market: "co",
    lang: "es",
    hreflang: "es-CO",
    dir: "ltr",
    localeMixing: ["es-CO", "es-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: "co",
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "cy-el",
    market: "cy",
    lang: "el",
    hreflang: "el-CY",
    dir: "ltr",
    localeMixing: ["el-CY"],
    storyblokLaunched: false,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "v3-widget",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: false,
    supportHubHomepageVariant: "image",
    measurementSystem: "metric",
  },
  {
    localeString: "cz-cs",
    market: "cz",
    lang: "cs",
    hreflang: "cs-CZ",
    dir: "ltr",
    localeMixing: ["cs-CZ"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "de-de",
    market: "de",
    lang: "de",
    hreflang: "de-DE",
    dir: "ltr",
    localeMixing: ["de-DE", "de-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "dk-da",
    market: "dk",
    lang: "da",
    hreflang: "da-DK",
    dir: "ltr",
    localeMixing: ["da-DK"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "ee-et",
    market: "ee",
    lang: "et",
    hreflang: "et-EE",
    dir: "ltr",
    localeMixing: ["et-EE"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "eg-ar",
    market: "eg",
    lang: "ar",
    hreflang: "ar-EG",
    dir: "rtl",
    localeMixing: ["ar-MEA", "ar-EG"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "eg-en",
    market: "eg",
    lang: "en",
    hreflang: "en-EG",
    dir: "ltr",
    localeMixing: ["en-MEA", "en-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "es-es",
    market: "es",
    lang: "es",
    hreflang: "es-ES",
    dir: "ltr",
    localeMixing: ["es-ES", "es-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "fi-fi",
    market: "fi",
    lang: "fi",
    hreflang: "fi-FI",
    dir: "ltr",
    localeMixing: ["fi-FI"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "fr-fr",
    market: "fr",
    lang: "fr",
    hreflang: "fr-FR",
    dir: "ltr",
    localeMixing: ["fr-FR", "fr-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: "fr",
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "gb-en",
    market: "gb",
    lang: "en",
    hreflang: "en-GB",
    dir: "ltr",
    localeMixing: ["en-GB", "en-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "gh-en",
    market: "gh",
    lang: "en",
    hreflang: "en-GH",
    dir: "ltr",
    localeMixing: ["en-GH"],
    storyblokLaunched: false,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "v3-widget",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: false,
    supportHubHomepageVariant: "image",
    measurementSystem: "metric",
  },
  {
    localeString: "gr-el",
    market: "gr",
    lang: "el",
    hreflang: "el-GR",
    dir: "ltr",
    localeMixing: ["el-GR"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "hk-zh",
    market: "hk",
    lang: "zh",
    hreflang: "zh-HK",
    dir: "ltr",
    localeMixing: ["zh-HK"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "hr-hr",
    market: "hr",
    lang: "hr",
    hreflang: "hr-HR",
    dir: "ltr",
    localeMixing: ["hr-HR"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "hu-hu",
    market: "hu",
    lang: "hu",
    hreflang: "hu-HU",
    dir: "ltr",
    localeMixing: ["hu-HU"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "id-id",
    market: "id",
    lang: "id",
    hreflang: "id-ID",
    dir: "ltr",
    localeMixing: ["en-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "ie-en",
    market: "ie",
    lang: "en",
    hreflang: "en-IE",
    dir: "ltr",
    localeMixing: ["en-IE", "en-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "in-en",
    market: "in",
    lang: "en",
    hreflang: "en-IN",
    dir: "ltr",
    localeMixing: ["en-IN", "en-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: "in",
    highInSugarMark: null,
    vegetarianMark: "in",
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "in-hi",
    market: "in",
    lang: "hi",
    hreflang: "hi-IN",
    dir: "ltr",
    localeMixing: ["hi-IN"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: "in",
    highInSugarMark: null,
    vegetarianMark: "in",
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "int-en",
    market: "int",
    lang: "en",
    hreflang: "en",
    dir: "ltr",
    localeMixing: ["en-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "is-is",
    market: "is",
    lang: "is",
    hreflang: "is-IS",
    dir: "ltr",
    localeMixing: ["is-IS"],
    storyblokLaunched: false,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "v3-widget",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: false,
    supportHubHomepageVariant: "image",
    measurementSystem: "metric",
  },
  {
    localeString: "it-it",
    market: "it",
    lang: "it",
    hreflang: "it-IT",
    dir: "ltr",
    localeMixing: ["it-IT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "jp-ja",
    market: "jp",
    lang: "ja",
    hreflang: "ja-JP",
    dir: "ltr",
    localeMixing: ["ja-JP"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "ke-en",
    market: "ke",
    lang: "en",
    hreflang: "en-KE",
    dir: "ltr",
    localeMixing: ["en-KE", "en-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "kr-ko",
    market: "kr",
    lang: "ko",
    hreflang: "ko-KR",
    dir: "ltr",
    localeMixing: ["ko-KR"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "kw-ar",
    market: "kw",
    lang: "ar",
    hreflang: "ar-KW",
    dir: "rtl",
    localeMixing: ["ar-MEA"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "kw-en",
    market: "kw",
    lang: "en",
    hreflang: "en-KW",
    dir: "ltr",
    localeMixing: ["en-MEA", "en-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "kz-kk",
    market: "kz",
    lang: "kk",
    hreflang: "kk-KZ",
    dir: "ltr",
    localeMixing: ["kk-KZ"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "kz-ru",
    market: "kz",
    lang: "ru",
    hreflang: "ru-KZ",
    dir: "ltr",
    localeMixing: ["ru-KZ"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "lt-lt",
    market: "lt",
    lang: "lt",
    hreflang: "lt-LT",
    dir: "ltr",
    localeMixing: ["lt-LT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "lv-lv",
    market: "lv",
    lang: "lv",
    hreflang: "lv-LV",
    dir: "ltr",
    localeMixing: ["lv-LV"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "mea-ar",
    market: "mea",
    lang: "ar",
    hreflang: "ar",
    dir: "rtl",
    localeMixing: ["ar-MEA"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "mea-en",
    market: "mea",
    lang: "en",
    hreflang: "en",
    dir: "ltr",
    localeMixing: ["en-MEA", "en-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: false, // Not a valid hreflang
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "mk-mk",
    market: "mk",
    lang: "mk",
    hreflang: "mk-MK",
    dir: "ltr",
    localeMixing: ["mk-MK"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "mu-fr",
    market: "mu",
    lang: "fr",
    hreflang: "fr-MU",
    dir: "ltr",
    localeMixing: ["fr-MU"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "v3-widget",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: false,
    supportHubHomepageVariant: "image",
    measurementSystem: "metric",
  },
  {
    localeString: "mx-es",
    market: "mx",
    lang: "es",
    hreflang: "es-MX",
    dir: "ltr",
    localeMixing: ["es-MX", "es-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "my-en",
    market: "my",
    lang: "en",
    hreflang: "en-MY",
    dir: "ltr",
    localeMixing: ["en-MY", "en-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "na-en",
    market: "na",
    lang: "en",
    hreflang: "en-NA",
    dir: "ltr",
    localeMixing: ["en-NA"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: false,
    supportHubHomepageVariant: "image",
    measurementSystem: "metric",
  },
  {
    localeString: "ng-en",
    market: "ng",
    lang: "en",
    hreflang: "en-NG",
    dir: "ltr",
    localeMixing: ["en-NG", "en-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "nl-nl",
    market: "nl",
    lang: "nl",
    hreflang: "nl-NL",
    dir: "ltr",
    localeMixing: ["nl-NL"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "no-no",
    market: "no",
    lang: "no",
    hreflang: "no-NO",
    dir: "ltr",
    localeMixing: ["no-NO"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "nz-en",
    market: "nz",
    lang: "en",
    hreflang: "en-NZ",
    dir: "ltr",
    localeMixing: ["en-NZ", "en-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "pe-es",
    market: "pe",
    lang: "es",
    hreflang: "es-PE",
    dir: "ltr",
    localeMixing: ["es-PE", "es-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: "pe",
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "ph-en",
    market: "ph",
    lang: "en",
    hreflang: "en-PH",
    dir: "ltr",
    localeMixing: ["en-PH", "en-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "pk-en",
    market: "pk",
    lang: "en",
    hreflang: "en-PK",
    dir: "ltr",
    localeMixing: ["en-PK", "en-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "pl-pl",
    market: "pl",
    lang: "pl",
    hreflang: "pl-PL",
    dir: "ltr",
    localeMixing: ["pl-PL"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "pt-pt",
    market: "pt",
    lang: "pt",
    hreflang: "pt-PT",
    dir: "ltr",
    localeMixing: ["pt-PT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "qa-ar",
    market: "qa",
    lang: "ar",
    hreflang: "ar-QA",
    dir: "rtl",
    localeMixing: ["ar-QA"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "qa-en",
    market: "qa",
    lang: "en",
    hreflang: "en-QA",
    dir: "ltr",
    localeMixing: ["en-MEA", "en-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "ro-ro",
    market: "ro",
    lang: "ro",
    hreflang: "ro-RO",
    dir: "ltr",
    localeMixing: ["ro-RO"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "rs-sr",
    market: "rs",
    lang: "sr",
    hreflang: "sr-RS",
    dir: "ltr",
    localeMixing: ["sr-RS"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "ru-ru",
    market: "ru",
    lang: "ru",
    hreflang: "ru-RU",
    dir: "ltr",
    localeMixing: ["ru-RU"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "v3-widget",
    legalDisclaimer: "ru",
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: false,
    supportHubHomepageVariant: "image",
    measurementSystem: "metric",
  },
  // TODO: Removed 2026-05, RB is unsure if this locale will return...
  // {
  //   localeString: "se-en",
  //   market: "se",
  //   lang: "en",
  //   hreflang: "en-SE",
  //   dir: "ltr",
  //   localeMixing: ["en-SE", "en-INT"],
  //   storyblokLaunched: true,
  //   includeInAlternateUrls: true,
  //   rbOccasionsCarouselVersion: "v3-widget",
  //   legalDisclaimer: null,
  //   highInSugarMark: null,
  //   vegetarianMark: null,
  // },
  {
    localeString: "se-sv",
    market: "se",
    lang: "sv",
    hreflang: "sv-SE",
    dir: "ltr",
    localeMixing: ["en-SE"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "sg-en",
    market: "sg",
    lang: "en",
    hreflang: "en-SG",
    dir: "ltr",
    localeMixing: ["en-SG", "en-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "si-sl",
    market: "si",
    lang: "sl",
    hreflang: "sl-SI",
    dir: "ltr",
    localeMixing: ["sl-SI"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "sk-sk",
    market: "sk",
    lang: "sk",
    hreflang: "sk-SK",
    dir: "ltr",
    localeMixing: ["sk-SK"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "sn-fr",
    market: "sn",
    lang: "fr",
    hreflang: "fr-SN",
    dir: "ltr",
    localeMixing: ["fr-SN"],
    storyblokLaunched: false,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "v3-widget",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: false,
    supportHubHomepageVariant: "image",
    measurementSystem: "metric",
  },
  {
    localeString: "tr-tr",
    market: "tr",
    lang: "tr",
    hreflang: "tr-TR",
    dir: "ltr",
    localeMixing: ["tr-TR"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "tw-zh",
    market: "tw",
    lang: "zh",
    hreflang: "zh-TW",
    dir: "ltr",
    localeMixing: ["zh-TW"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "tz-en",
    market: "tz",
    lang: "en",
    hreflang: "en-TZ",
    dir: "ltr",
    localeMixing: ["en-TZ"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "v3-widget",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: false,
    supportHubHomepageVariant: "image",
    measurementSystem: "metric",
  },
  {
    localeString: "ua-uk",
    market: "ua",
    lang: "uk",
    hreflang: "uk-UA",
    dir: "ltr",
    localeMixing: ["uk-UA"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
  {
    localeString: "ug-en",
    market: "ug",
    lang: "en",
    hreflang: "en-UG",
    dir: "ltr",
    localeMixing: ["en-UG"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "v3-widget",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: false,
    supportHubHomepageVariant: "image",
    measurementSystem: "metric",
  },
  {
    localeString: "us-en",
    market: "us",
    lang: "en",
    hreflang: "en-US",
    dir: "ltr",
    localeMixing: ["en-US", "en-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "imperial",
  },
  {
    localeString: "xk-sq",
    market: "xk",
    lang: "sq",
    hreflang: "sq-XK",
    dir: "ltr",
    localeMixing: ["sq-XK"],
    storyblokLaunched: false,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "v3-widget",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: false,
    supportHubHomepageVariant: "image",
    measurementSystem: "metric",
  },
  {
    localeString: "za-en",
    market: "za",
    lang: "en",
    hreflang: "en-ZA",
    dir: "ltr",
    localeMixing: ["en-ZA", "en-INT"],
    storyblokLaunched: true,
    includeInAlternateUrls: true,
    rbOccasionsCarouselVersion: "rb-smart-component",
    legalDisclaimer: null,
    highInSugarMark: null,
    vegetarianMark: null,
    supportHubSearch: true,
    supportHubHomepageVariant: "featured",
    measurementSystem: "metric",
  },
];

/**
 * @satisfies {Partial<import("./locales.types").Locale>}
 */
export const nextLocale = {
  localeString: "ne-xt",
  dir: "ltr",
  lang: "en",
  market: "next",
  hreflang: "en",
  localeMixing: ["en-INT"],
  storyblokLaunched: true,
  includeInAlternateUrls: true,
  rbOccasionsCarouselVersion: "rb-smart-component",
  legalDisclaimer: null,
  highInSugarMark: null,
  vegetarianMark: null,
  supportHubSearch: true,
  supportHubHomepageVariant: "featured",
  measurementSystem: "imperial",
};

/**
 * Map of locales by market.
 * Example:
 * ```
 * Map {
 *   "at" => [{ localeString: "at-de", ... }, { localeString: "at-en", ... }],
 *   "be" => [{ localeString: "be-fr", ... }, { localeString: "be-nl", ... }],
 *   "us" => [{ localeString: "us-en", ... }, { localeString: "us-es", ... }],
 *   ...
 * }
 * ```
 *
 * @type {Map<string, typeof locales>}
 */
export const localesByMarket = locales.reduce(
  (map, locale) =>
    map.set(locale.market, [...(map.get(locale.market) ?? []), locale]),
  new Map(),
);
